import { render, staticRenderFns } from "./AthleteScoutingReportsView.vue?vue&type=template&id=6b3e4f3e&scoped=true&"
import script from "./AthleteScoutingReportsView.vue?vue&type=script&lang=ts&"
export * from "./AthleteScoutingReportsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3e4f3e",
  null
  
)

export default component.exports